import { createRoot } from "react-dom/client";
import "@/lib/styles/main.style.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(<App />);
